import { render, staticRenderFns } from "./bodyright.vue?vue&type=template&id=0498b203"
import script from "./bodyright.vue?vue&type=script&lang=js"
export * from "./bodyright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports